export default "__VITE_ASSET__f787bbd4__"